module.exports = "/_next/static/public/images/6017c07cc51f5b0749c989956dc01f29-c53cc7e48a950ac9ada69a765dbcf6eb.png";